/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */
import React from 'react';

import { Button, Icon, Segment } from '@mairistem/composants';

import type { Steps } from '@/types';

interface Props {
  /** Index de l'étape actuelle */
  currentStepIndex: number;
  /** Nombre total d'étapes */
  nbSteps: number;
  /** En chargement */
  loading: boolean;
  /** Callback appelé lors du changement d'étape */
  onStepChange: (stepIndex: Steps) => void;
  /** Callback appelé lors du clique sur le bouton 'Terminer' */
  onFinish: () => void;
  /** Désactive le bouton "étape suivante" */
  nextDisabled?: boolean;
  /** Cache le bouton de validation finale (mode vérification seule) */
  modeVerification?: boolean;
  /** Index de la première étape visible (pour masquer le bouton Précédent) */
  firstStepIndex?: number;
}

const AssistantFooter = (props: Props) => {
  // #region Declarations
  const {
    currentStepIndex,
    onStepChange,
    onFinish,
    nbSteps,
    loading,
    nextDisabled = false,
    modeVerification = false,
    firstStepIndex = 0,
  } = props;

  // #endregion

  // #region Component

  return (
    <Segment
      style={{
        display: 'flex',
        borderBottom: 'none',
        borderLeft: 'none',
        borderRight: 'none',
        background: 'transparent',
        boxShadow: 'none',
      }}
    >
      {currentStepIndex !== firstStepIndex && (
        <Button
          data-testid="assistant-etape-precedente"
          onClick={() => onStepChange(currentStepIndex - 1)}
          disabled={loading}
          loading={loading}
        >
          <Icon name="angle left" />
          Étape précédente
        </Button>
      )}
      <div style={{ flex: 1 }} />
      {currentStepIndex === nbSteps - 1 && !modeVerification ? (
        <Button
          positive
          data-testid="assistant-terminer"
          onClick={onFinish}
          disabled={loading}
          loading={loading}
        >
          <Icon name="flag checkered" />
          Valider l&apos;apposition
        </Button>
      ) : (
        <Button
          data-testid="assistant-etape-suivante"
          onClick={() => onStepChange(currentStepIndex + 1)}
          disabled={loading || nextDisabled}
          loading={loading}
        >
          Étape suivante
          <Icon name="angle right" />
        </Button>
      )}
    </Segment>
  );
};

export default AssistantFooter;
